export const inputAffixBackgroundClasses = {
    primary: 'bg-slate-50 dark:bg-neutral-800',
    secondary: 'bg-slate-25 dark:bg-neutral-800',
    danger: 'bg-danger-100 dark:bg-danger-900 text-danger-600',
    transparent: 'bg-transparent',
};
